import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import MotorReservaRoomRatesAPI from '../../api/motorReservaRoomRates';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getRecords({ commit }) {
    commit(types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG, { isFetching: true });
    try {
      const response = await MotorReservaRoomRatesAPI.get();
      commit(types.SET_MOTOR_RESERVA_ROOM_RATES, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createRecord({ commit, dispatch }, data) {
    commit(types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG, { isCreating: true });
    try {
      await MotorReservaRoomRatesAPI.create(data);
      await dispatch('get');
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateRecord({ commit }, { id, ...updateObj }) {
    commit(types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG, { isUpdating: true });
    try {
      const response = await MotorReservaRoomRatesAPI.update(id, updateObj);
      commit(types.EDIT_MOTOR_RESERVA_ROOM_RATE, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteRecord({ commit, dispatch }, id) {
    commit(types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG, { isDeleting: true });
    try {
      await MotorReservaRoomRatesAPI.delete(id);
      await dispatch('get');
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG, { isDeleting: false });
    }
  },

  massCombine: async function massCombineRecords({ commit, dispatch }, combinations) {
    commit(types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG, { isCreating: true });
    try {
      await MotorReservaRoomRatesAPI.massCombine(combinations);
      await dispatch('get');
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG, { isCreating: false });
    }
  },
};

export const mutations = {
  [types.SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_MOTOR_RESERVA_ROOM_RATES]: MutationHelpers.set,
  [types.ADD_MOTOR_RESERVA_ROOM_RATE]: MutationHelpers.create,
  [types.EDIT_MOTOR_RESERVA_ROOM_RATE]: MutationHelpers.update,
  [types.DELETE_MOTOR_RESERVA_ROOM_RATE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
